import { API_CONFIG } from "../config/api";

const API_BASE_URL = API_CONFIG.BASE_URL;

export class SubCategoryService {
  static async getAuthHeaders(getAccessTokenSilently) {
    const token = await getAccessTokenSilently();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  // Create sub-category
  static async createSubCategory(data, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(`${API_BASE_URL}/sub-categories`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to create sub-category");
    }

    return response.json();
  }

  // Bulk create sub-categories
  static async bulkCreateSubCategories(data, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(`${API_BASE_URL}/sub-categories/bulk-create`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(
        errorData.error || "Failed to bulk create sub-categories"
      );
      error.bulk_errors = errorData.errors;
      throw error;
    }

    return response.json();
  }

  // Bulk update sub-categories
  static async bulkUpdateSubCategories(data, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(`${API_BASE_URL}/sub-categories/bulk-update`, {
      method: "PUT",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      const error = new Error(
        errorData.error || "Failed to bulk update sub-categories"
      );
      error.bulk_errors = errorData.errors;
      throw error;
    }

    return response.json();
  }

  // Get all sub-categories for organization
  static async getSubCategories(organizationId, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories?organization_id=${organizationId}`,
      { headers }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch sub-categories");
    }

    return response.json();
  }

  // Get sub-categories for specific category
  static async getSubCategoriesForCategory(
    categoryId,
    organizationId,
    getAccessTokenSilently
  ) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories/category/${categoryId}?organization_id=${organizationId}`,
      { headers }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Failed to fetch sub-categories for category"
      );
    }

    return response.json();
  }

  // Get specific sub-category
  static async getSubCategory(subCategoryId, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories/${subCategoryId}`,
      {
        headers,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch sub-category");
    }

    return response.json();
  }

  // Update sub-category
  static async updateSubCategory(subCategoryId, data, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories/${subCategoryId}`,
      {
        method: "PUT",
        headers,
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to update sub-category");
    }

    return response.json();
  }

  // Delete sub-category
  static async deleteSubCategory(subCategoryId, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories/${subCategoryId}`,
      {
        method: "DELETE",
        headers,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to delete sub-category");
    }

    return response.json();
  }

  // Validate prefix
  static async validatePrefix(prefix, organizationId, getAccessTokenSilently) {
    const headers = await this.getAuthHeaders(getAccessTokenSilently);
    const response = await fetch(
      `${API_BASE_URL}/sub-categories/validate-prefix?prefix=${encodeURIComponent(
        prefix
      )}&organization_id=${organizationId}`,
      { headers }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to validate prefix");
    }

    return response.json();
  }
}
